import { gql } from "@apollo/client"

export type KeyValuePair = {
  key: string
  value: string
}

export type EledoPlan = {
  id: number
	name: string
	price: number
	templates: number
	documents: number
	maxImgDpi: number
	overquota: boolean
	oqPrice: number
	support: string
}

export type EledoPlanState = {
  availablePlans: EledoPlan[]
  currentPlan: EledoPlan
	currentPlanLevel: number
	subscriptionType: string
	subscriptionTypes: KeyValuePair[]
	paymentMethod: string
	paymentMethods: KeyValuePair[]
	nextPlan: EledoPlan
	nextPlanLevel: number
	nextPlanStart: Date
	nextSubscriptionType: string
	nextPaymentMethod: string
}

export type EledoPlanStateVars = {
}

export type EledoPlanStateData = {
  currentPlan: EledoPlanState
}

export const GET_CURRENT_PLAN = gql`
  query getCurrentPlan {
    currentPlan { availablePlans { id name price templates documents maxImgDpi overquota oqPrice support } currentPlan { name price templates documents maxImgDpi overquota oqPrice support } currentPlanLevel subscriptionType subscriptionTypes { key value }
      paymentMethod paymentMethods { key value } nextPlan { name price templates documents maxImgDpi overquota oqPrice support } nextPlanLevel nextPlanStart nextSubscriptionType nextPaymentMethod }
  }
`;

